import React, { useState, useEffect } from 'react';
import { Card, Modal, Button } from 'semantic-ui-react';
import { Loading } from 'react-lib/dist/components-es';
import { withTranslation, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { VIEW_MODE } from '../../../../constants';
import ReadOnlyMapContainer from '../../../BuildingSummary/ReadOnlyMapContainer';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { Inventory } from '../../../../routes';
import { history } from '../../../../store';
import Title from './Components/Title';
import HazardIcon from './Components/HazardIcon';
import SimplifiedInventoryLabel, { LabelType } from './Components/SimplifiedInventoryLabel';
import DownloadableFileWrapper from './Components/DownloadableFileWrapper';
import useInventoryShort from '@behavior/inventories/getInventoryShort';
import AccordionPersonList from './Components/AccordionPersonList';

import stylesMobile from './Components/styles/InventoryOverviewMobile.module.scss';

const InventoryOverviewMobileComponent = ({ id, mode, isLoading, showPersonalData }) => {
  const { t } = useTranslation();
  const [mapImage, setMapImage] = useState(null);
  const [inventorySimplified, setInventorySimplified] = useState(null);
  const { getInventoryShort } = useInventoryShort(id);

  useEffect(() => {
    getInventoryShort(id).then(inventory => {
      if (inventory) {
        setInventorySimplified(inventory);
      }
    });
  }, []);

  const { inventory } = inventorySimplified || {};
  const [openGIS, setOpenGIS] = useState(false);

  const { chemicalProduct, orgUnit, location, contacts } = inventory || {};

  const { tradeName, hazardStatements } = chemicalProduct || '';
  const { hazards, casNumber, unNumber, sdsFiles } = chemicalProduct || {};
  const { name } = orgUnit || '';
  const personList = [];
  const hazardStatement = [];
  const fileDataList = [];

  if (contacts !== undefined) {
    contacts.map(contact => {
      const { person } = contact || {};
      return personList.push(person);
    });
  }

  if (sdsFiles !== undefined) {
    sdsFiles.map(file => {
      const { fileData } = file || {};
      return fileDataList.push(fileData);
    });
  }

  if (hazardStatements !== undefined) {
    hazardStatements.map(newHazardStatement => {
      const statement = newHazardStatement.statement;
      const description = newHazardStatement.description;
      return hazardStatement.push({ statement, description });
    });
  }

  const redirectHandler = mode => {
    history.push(Inventory.baseName + `/${mode}` + (id ? `/${id}` : `/:id`));
  };

  if (isLoading) {
    return (
      <>
        <Loading isLoading={isLoading} />
      </>
    );
  }
  return (
    <div>
      {!isLoading && inventory && (
        <Card className={stylesMobile.card}>
          <Title inventory={inventory} isMobile />
          <Card.Content className={stylesMobile.cardContent}>
            <Card.Description className={stylesMobile.cardDiv}>
              <SimplifiedInventoryLabel labelType={LabelType.organicUnit} value={name} isMobile />

              <div className={stylesMobile.accordionPersonList}>
                <AccordionPersonList personList={personList} showPersonalData={showPersonalData} />
              </div>
              <Card className={stylesMobile.chemicalInformationCardMobile}>
                <HazardIcon hazards={hazards} />

                <SimplifiedInventoryLabel
                  labelType={LabelType.unNumber}
                  value={unNumber?.unNumber}
                />

                <SimplifiedInventoryLabel
                  labelType={LabelType.casNumber}
                  value={casNumber?.casNumber}
                />

                <SimplifiedInventoryLabel
                  labelType={LabelType.hazardStatement}
                  value={hazardStatement}
                />

                <DownloadableFileWrapper fileData={fileDataList} isMobile />
              </Card>
              <div className={stylesMobile.ButtonWrapperMobileDiv}>
                <Modal
                  closeIcon
                  onOpen={() => setOpenGIS(true)}
                  open={openGIS}
                  onClose={() => setOpenGIS(false)}
                  trigger={
                    <Button
                      type="submit"
                      label={t('gis.modal.precise.location.trigger.label')}
                      primary
                      color="blue"
                      icon="map outline"
                    />
                  }
                  centered
                  size="huge"
                  className={stylesMobile.GISmapMobile}
                >
                  <Modal.Header>{t('gis.modal.precise.location.title')}</Modal.Header>
                  <div className={stylesMobile.GISmapMobileDiv}>
                    <ReadOnlyMapContainer
                      location={location}
                      setMapImage={setMapImage}
                      isBuilding={false}
                      scale={100}
                    />
                  </div>
                </Modal>
                <ButtonWrapper
                  type="button"
                  onClick={() => redirectHandler(VIEW_MODE)}
                  label={t('details.button')}
                  color={'blue'}
                  size={'medium'}
                  icon="zoom-in"
                  className={stylesMobile.ButtonWrapperMobile}
                />
              </div>
            </Card.Description>
          </Card.Content>
        </Card>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.match.params.id,
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(InventoryOverviewMobileComponent);
